if (!customElements.get('bulk-discount-faded-out')) {
  customElements.define(
    'bulk-discount-faded-out',
    class BulkDiscountFadedOut extends HTMLElement {
      constructor() {
        super();
        this.container = this.querySelector('.bulk-discount-faded-out__container');
        this.expandBtn = this.querySelector('.bulk-discount-faded-out__expand');
        this.hideBtn = this.querySelector('.bulk-discount-faded-out__hide');

        if (this.expandBtn) {
          this.expandBtn.addEventListener('click', this.toggle.bind(this));
        }

        if (this.hideBtn) {
          this.hideBtn.addEventListener('click', this.hide.bind(this));
        }
      }

      expand() {
        this.classList.add('is-expanded');
        this.container.classList.add('is-expanded');
      }

      hide() {
        this.classList.remove('is-expanded');
        this.container.classList.remove('is-expanded');
      }

      toggle() {
        if (this.classList.contains('is-expanded')) {
          this.hide();
        } else {
          this.expand();
        }
      }
    }
  );
}
